import { ReelItemType } from "./../../models/reel-item";
import {autoinject} from "aurelia-dependency-injection";
import Marionette from "../../../shared/marionette-mustache";
import {backboneViewProperties} from "../../../decorators/backbone-properties";
import { ReelItemModel } from "../../models/reel-item";
import { ReelItemView } from "./reel-item";

const searchItemTemplate = require<string>("./search-reel-item.html");
const docItemTemplate = require<string>("./document-reel-item.html");
const resourceItemTemplate = require<string>("./resource-reel-item.html");
const productItemTemplate = require<string>("./product-reel-item.html");
const placeholderItemTemplate = require<string>("./placeholder-reel-item.html");

@backboneViewProperties({
    className: "reel-list js-reel-list",
    childView: ReelItemView
})
export class ReelListView extends Marionette.CollectionView<ReelItemModel, ReelItemView> {

    constructor(private options?) { // : Marionette.CollectionViewOptions<ReelItemModel>) {
        super(options);
    }

    public buildChildView(childModel: ReelItemModel, className, childViewOptions) {
        let template;
        switch (childModel.ItemType) {
            case ReelItemType.SearchResult:
                template = searchItemTemplate;
                break;
            case ReelItemType.Document:
                template = docItemTemplate;
                break;
            case ReelItemType.Resource:
                template = resourceItemTemplate;
                break;
            case ReelItemType.Product:
                template = productItemTemplate;
                break;
            case ReelItemType.Placeholder:
                template = placeholderItemTemplate;
                break;
        }
        return new ReelItemView({model: childModel, template});
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/partials/reel-list.ts